import '../styles/pages/CreateAccountPage.css';
import React, { useState } from 'react';
import SignUpForm from '../components/create_account_page/SignUpForm';

const CreateAccountPage = () => {
    const [userType, setUserType] = useState(null);

    const handleUserTypeSelection = (type) => {
        setUserType(type);
    };

    const resetUserType = () => {
        setUserType(null);
    };

    return (
        <div className="account-creation-page">
            {!userType ? (
                <>
                    <header className="account-creation-intro">
                        <h1>Join ViewFinders</h1>
                        <p>Choose how you'd like to use the platform.</p>
                    </header>
                    <div className="account-creation-sections">
                        {/* Photographer Section */}
                        <button
                            type="button"
                            className="account-creation-section photographer-section"
                            onClick={() => handleUserTypeSelection('photographer')}
                        >
                            <span className="account-creation-card-overlay" />
                            <span className="account-creation-card-content">
                                <span className="account-creation-card-kicker">Photographer</span>
                                <span className="account-creation-card-title">Join as a photographer</span>
                                <span className="account-creation-card-copy">
                                    Showcase your work, manage enquiries and get discovered by new clients.
                                </span>
                            </span>
                        </button>

                        {/* Client Section */}
                        <button
                            type="button"
                            className="account-creation-section client-section"
                            onClick={() => handleUserTypeSelection('user')}
                        >
                            <span className="account-creation-card-overlay" />
                            <span className="account-creation-card-content">
                                <span className="account-creation-card-kicker">Client</span>
                                <span className="account-creation-card-title">Find a photographer</span>
                                <span className="account-creation-card-copy">
                                    Discover photographers, compare options and start planning your shoot.
                                </span>
                            </span>
                        </button>
                    </div>
                </>
            ) : (
                <div className="signup-form-container">
                    <button className="back-button" onClick={resetUserType}>
                        ← Back
                    </button>
                    <SignUpForm userType={userType} />
                </div>
            )}
        </div>
    );
};

export default CreateAccountPage;
